import { AxiosResponse } from 'axios';
import { call, fork, put, takeEvery } from 'redux-saga/effects';

import { SettingsOptionsDataResend } from '../domain/settingOptionsDataResend';

import {
  SettingsOptionsDataResendActionCreators,
  SettingsOptionsDataResendActionTypes,
} from '../redux/server/settingsOptionsDataResend';
import { Api, buildConfig } from '../utils/api';
import { handleErrorSaga } from './errorSaga';

export function* fetchSettingsOptionsDataResendSaga(api: Api) {
  try {
    yield put(
      SettingsOptionsDataResendActionCreators.fetchSettingsOptionsDataResendRequestAction()
    );
    const response: AxiosResponse<SettingsOptionsDataResend> = yield call(
      api.get,
      '/settings/options/dataResend',
      buildConfig()
    );
    yield put(
      SettingsOptionsDataResendActionCreators.fetchSettingsOptionsDataResendSuccessAction(
        response.data
      )
    );
  } catch (error: unknown) {
    yield put(
      SettingsOptionsDataResendActionCreators.renewSettingsOptionsDataResendAction()
    );
    yield fork(handleErrorSaga, error);
  }
}

function* handleFetchSettingsOptionsDataResendSaga(api: Api) {
  yield takeEvery(
    SettingsOptionsDataResendActionTypes.FETCH_SETTINGS_OPTIONS_DATARESEND,
    fetchSettingsOptionsDataResendSaga,
    api
  );
}

export function* settingsOptionsDataResendSagas(context: { api: Api }) {
  yield fork(handleFetchSettingsOptionsDataResendSaga, context.api);
}
